import React, { FunctionComponent } from 'react';
import { useForm } from 'react-hook-form';

import { SubmitButton } from 'components/SubmitButton';
import { DateOfBirthQuestion } from 'scenes/common/components/Questions';
import { SingleFieldStepProps } from 'scenes/common/types';

const MIN_AGE = 18;
const MAX_AGE = 100;

const SingleDateOfBirthStep: FunctionComponent<
  Pick<
    SingleFieldStepProps<string>,
    'defaultStateValue' | 'onNext' | 'stateKey' | 'question'
  > & {
    entityType: string;
  }
> = ({ onNext, stateKey, question, entityType, defaultStateValue }) => {
  const { formState: hooksForm, handleSubmit, control, errors } = useForm({
    mode: 'onChange',
  });

  return (
    <form onSubmit={handleSubmit(onNext)}>
      <DateOfBirthQuestion
        errors={errors}
        minAge={MIN_AGE}
        maxAge={MAX_AGE}
        control={control}
        question={question}
        stateKey={stateKey}
        entityType={entityType}
        defaultValue={defaultStateValue}
      />
      <SubmitButton enabled={hooksForm.isValid}>Next</SubmitButton>
    </form>
  );
};

export default SingleDateOfBirthStep;
